import React from 'react';
import Footer from './Footer';

const Bayan = ({name, nationality, selectedCrimes}) => {

    const crimeMap = {
    'بنزين': 'تعبئتة للبنزين بدون دفع',
    'تفحيط': 'تفحيطه للفجر',
    'تغريدة': 'كتابته لتغريدات',
    'كفرات': 'سرقته للكفرات',
    'إرهاب': 'انضمامه لخلية ارهابية وتمويله للإرهاب',
    'ثلاجة': 'حصوله على الضمان الاجتماعي بغير حق'
    };

    const crimes = selectedCrimes.map((crime) => crimeMap[crime]);

    const generateRandomHijriDate = () => {
    const year = Math.floor(Math.random() * (1446 - 1435 + 1)) + 1435;
    const month = Math.floor(Math.random() * 12) + 1;
    const day = Math.floor(Math.random() * 29) + 1;
    return `${year}/${month}/${day}`;
    };

    const getTodaysHijriDate = () => {
        // use locale to get the current date in Hijri
        const today = new Date();
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return today.toLocaleDateString('ar-SA-u-ca-islamic', options);
    };

    const getTodaysNormalDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        const day = today.getDate();
        return `${year}/${month}/${day}`;
    };
        

    



  const generateStatement = () => {
    return `أصدرت وزارة الداخلية اليوم، بيانا بشأن تنفيذ حكم القتل بأحد الجناة فيما يلي نصه:
قال الله تعالى : (يا أيها الذين آمنوا لا تخونوا الله والرسول وتخونوا أماناتكم وأنتم تعلمون).
بتوفيق من الله وعلى ضوء ما توفر لدى الجهات الأمنية من معلومات تم القبض بتاريخ ${generateRandomHijriDate()}هـ على / ${name} - ${nationality} الجنسية - لارتكابه أفعالا مجرمة تنطوي على خيانة وطنه و${crimes.join(' و')}.
وانتهى التحقيق من قبل النيابة العامة إلى توجيه الاتهام للمذكور بارتكاب تلك الأفعال المجرمة، وبإحالته إلى المحكمة الجزائية المتخصصة صدر بحقه حكم يقضي بثبوت ادانته بما أسند إليه، والحكم عليه بالقتل، وأيد الحكم من محكمة الاستئناف الجزائية المتخصصة ومن المحكمة العليا، وتم تنفيذ حكم القتل بالمذكور يوم ${getTodaysHijriDate()} الموافق ${getTodaysNormalDate()}م بمنطقة الرياض. 
ووزارة الداخلية إذ تعلن عن ذلك لتؤكد الحرص على استتباب الأمن وتحقيق العدل، وقطع دابر كل من يحاول المساس بأمن الوطن أو تعريض وحدته للخطر وأن العقاب الشرعي سيكون مصير كل من تسول له نفسه ارتكاب ذلك قطعا لشره وردعا لغيره. 
والله الهادي إلى سواء السبيل.`;
  };

  return (

    <div className="min-h-screen bg-gray-100 font-manal">
      <div className="max-w-2xl mx-auto p-4">
      <header className="bg-red-600 text-white p-4 text-center mb-4">
        <h1 className="lg:text-3xl text-xl font-bold">تنفيذ حكم القتل بحق أحد الجناة</h1>
      </header>
      
      <div className="bg-white p-4 mb-4 shadow-md">
       
      <div className="text-right whitespace-pre-line text-sm lg:text-2xl text-bayan-gray" dir="rtl">
          {generateStatement()}
        </div>
      </div>
      
      <Footer />
    </div>
  </div>
  );
};

export default Bayan;